export default "__VITE_ASSET__kOzCADhw__"